import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiReturnCreate } from '@/entities/returns/modules/api/returns';

export const useCreateReturn = () =>
  useMutate({
    api: apiReturnCreate,
    invalidateKeys: [queryKeys.returns.all, queryKeys.parcels.availableForReturn],
  });
